import { Button, TrashIcon } from '@ag1/ui';
import { sendViewCartEvent } from '@portal/analytics/events/ecommerce';
import { mapCartLinesToGAEventsEcommerceItems } from '@portal/shared/components/CartModal/utils/analytics';
import { useSiteCart } from '@portal/shared/components/SiteCart/hooks/SiteCartContext';
import { SSGates } from '@portal/state/context/StatsigContext/StatsigFlags';
import { useStoreValue } from '@portal/state/hooks/useStore';
import { useStoreCurrency } from '@portal/state/hooks/useStoreCurrency';
import { useGateValue } from '@statsig/react-bindings';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { SiteCartEmptyState } from '../SiteCartEmptyState/SiteCartEmptyState';
import { SiteCartProgressBar } from '../SiteCartProgressBar/SiteCartProgressBar';
import { SiteCartSection } from '../SiteCartSection/SiteCartSection';
import { SiteCartUpsell } from '../SiteCartUpsell/SiteCartUpsell';
import styles from './SiteCartContent.module.scss';

export const SiteCartContent = () => {
  const store = useStoreValue();
  const { currency } = useStoreCurrency();
  const { t } = useTranslation('siteCart');
  const isAgzGateEnabled = useGateValue(SSGates.enableAGZ);
  const { cart, paidOtpItems, paidSubItems, freeItems, clearCart, isCartUpdating, isDebugMode } =
    useSiteCart();

  useEffect(() => {
    if (!cart?.lines?.length) {
      return;
    }

    sendViewCartEvent({
      checkoutType: 'unified',
      cartStatus: 'Full',
      ecommerce: {
        currency,
        cart_value: cart.cost?.totalAmount?.amount,
        items: mapCartLinesToGAEventsEcommerceItems({
          cartLines: cart.lines,
          currency,
          cartDiscountCodes: cart.discountCodes ?? [],
          store
        })
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!cart?.lines.length) return <SiteCartEmptyState />;

  return (
    <div className={styles.container}>
      {/* PROGRESS BAR - disabled for P1 */}
      {isDebugMode && <SiteCartProgressBar />}

      {/* SUBSCRIPTION ITEMS */}
      <SiteCartSection sectionName={t('subscriptionTitle')} items={paidSubItems} isSubscription />

      {/* OTP ITEMS */}
      <SiteCartSection sectionName={t('oneTimeTitle')} items={paidOtpItems} />

      {/* FREE ITEMS */}
      <SiteCartSection sectionName={t('freeGiftsTitle')} items={freeItems} />

      {/* Clear All */}
      <div className={styles.clearAllContainer}>
        <Button
          variant="link"
          size="small"
          noPadding
          onClick={clearCart}
          disabled={isCartUpdating}
          icon={<TrashIcon />}
          iconClassName={styles.clearAllIcon}>
          {t('clearCartText')}
        </Button>
      </div>

      {/* Phase 2 */}
      {/* {paidOtpItems.length > 0 && <NextSubscriptionOrderUpsell />} */}

      {/* UPSELL - Use AGZ release gate for non-empty cart */}
      {isAgzGateEnabled && <SiteCartUpsell showTitle />}
    </div>
  );
};
